var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.023,
    height: 43.022,
    viewBox: "0 0 43.023 43.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.sdfsadsdf{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.023V43.022H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sdfsadsdf",
    d: "M19.7,6.942a1.785,1.785,0,0,0-2.528,0L8.942,15.17a1.785,1.785,0,0,0,0,2.528l8.228,8.228A1.787,1.787,0,0,0,19.7,23.4l-6.955-6.973L19.7,9.469A1.8,1.8,0,0,0,19.7,6.942Z",
    transform: "translate(6.672 5.086)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.3b27fc6b.svg";
export { ForwardRef as ReactComponent };